import { Tag } from '@/design-system/Tag'

export const BetaTag = () => (
  <Tag variant='beta'>
    TRIAL
  </Tag>
)
